import { CopilotConversationDTO, PromptResponseCitationDTO } from './copilotConversationDTO';

export class SupplierComplianceStandardDTO {
  code?: string;

  status?: string;

  issuer?: string;

  validFrom?: string;

  validTo?: string;

  citations?: PromptResponseCitationDTO[];

  fileUrl?: string;

  delta?: number;
}

export class SupplierComplianceBaselineDTO {
  investigated?: string;

  standards?: SupplierComplianceStandardDTO[];

  savedLinkIds?: number[];

  status?: number;
}

export class SupplierComplianceDocumentDTO {
  linkId?: number;

  name?: string;

  version?: string;

  modified?: string;
}

export class SupplierDocumentCheckDTO {
  verdict?: number;

  issuer?: string;

  standard?: string;

  scope?: string;

  subject?: string;

  validFrom?: string;

  validTo?: string;

  reasons?: string[];
}

// Where a staged file would land and whether it replaces a version there; filled at Review and again after a save
export class SupplierSavePlanDTO {
  folderPath?: string;

  fileName?: string;

  existingLinkId?: number | null;

  existingVersion?: string | null;

  warnings?: string[];
}

export class SupplierStagedFileDTO {
  index?: number;

  blockId?: string;

  tempBlobName?: string;

  fileName?: string;

  contentType?: string;

  size?: number;

  sha256?: string;

  sourceUrl?: string;

  standardCode?: string;

  check?: SupplierDocumentCheckDTO;

  decision?: number;

  // SupplierComplianceFileOrigin
  origin?: number;

  // SupplierComplianceFileVerdict; null until the reconcile placed the file
  fileVerdict?: number | null;

  savedLinkId?: number;

  savedVersion?: string;

  savedOn?: string | null;

  savePlan?: SupplierSavePlanDTO | null;

  // the refusal of the plan or the save (a code such as OUTPUTLOC0007), cleared on success
  saveError?: string | null;
}

// The Data of the SupplierCompliance process row (ProcessStateSupplierCompliance, PLAN-073)
export class TenantProcessStateSupplierComplianceDTO {
  assetId?: number;

  assetName?: string;

  stage?: number;

  previousOutcome?: SupplierComplianceBaselineDTO;

  existingDocuments?: SupplierComplianceDocumentDTO[];

  standards?: SupplierComplianceStandardDTO[];

  summaryMarkdown?: string;

  stagedFiles?: SupplierStagedFileDTO[];

  consumerTaskId?: number;

  // the run's own Copilot session, made at Staging: the staged File blocks live in it
  sessionId?: number | null;

  // request only: the stage command, read once (save:<index>, skip:<index>, saveAllMatched, a card's command)
  command?: string;

  conversation: CopilotConversationDTO;

  constructor() {
    this.conversation = new CopilotConversationDTO();
  }
}
